import { scrollToTop, scrollToUpNext, updateShouldAutoScroll } from '../actions/internalActions';
import { getUpNextCalendarEventDate } from '../selectors/upNextEventCalendarCacheSelectors';
import { isSameDay } from 'owa-datetime';
import type { DateRange } from 'owa-datetime-utils';

export function refreshScrollingForDateRange(agendaScenarioId: string, dateRange: DateRange) {
    const upNextEventDate = getUpNextCalendarEventDate(agendaScenarioId);
    if (!upNextEventDate || !isSameDay(dateRange.start, upNextEventDate)) {
        // Reset the scroll position
        scrollToTop(agendaScenarioId);
        updateShouldAutoScroll(false, agendaScenarioId);
    } else {
        updateShouldAutoScroll(true, agendaScenarioId);
        scrollToUpNext(agendaScenarioId);
    }
}
